import { FormCheckbox, FormDatePicker, FormInput, Dialog } from "@/components";
import { FormProvider } from "react-hook-form";
import { BLOCK_BY, BLOCK_DATE, PAYMENT_BLOCK } from "../consts";
import usePaymentBlockDialog from "./usePaymentBlockDialog";
import { Button, DialogClose, DialogFooter } from "@/components/ui";
import { FC } from "react";
import { PaymentBlockDialogProps } from "./types";

const PaymentBlockDialog: FC<PaymentBlockDialogProps> = ({
  allDisabled,
  open,
  setOpen,
  defaultValues,
  onSavePaymentBlock,
}) => {
  const { form, onSubmit, requiredFields } = usePaymentBlockDialog({
    defaultValues,
    onSavePaymentBlock,
  });
  const { errors } = form.formState;

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={
        <div className="text-2xl font-bold text-primary">
          {"Payment Block"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      hideFooter
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 gap-[20px]">
            <FormCheckbox
              name={PAYMENT_BLOCK}
              control={form.control}
              label="Payment Block"
              placeholder="Please enter"
              error={errors[PAYMENT_BLOCK]?.message}
              isRequired={requiredFields.includes(PAYMENT_BLOCK)}
              disabled={allDisabled}
            />
            {form.watch(PAYMENT_BLOCK) && (
              <>
                <FormDatePicker
                  name={BLOCK_DATE}
                  control={form.control}
                  label="Block Date"
                  placeholder="Please select"
                  error={errors[BLOCK_DATE]?.message}
                  isRequired={requiredFields.includes(BLOCK_DATE)}
                  disabled={allDisabled}
                />
                <FormInput
                  name={BLOCK_BY}
                  control={form.control}
                  label="Block By"
                  placeholder="Please enter"
                  error={errors[BLOCK_BY]?.message}
                  isRequired={requiredFields.includes(BLOCK_BY)}
                  disabled
                />
              </>
            )}
          </div>

          <DialogFooter className="mt-5">
            <DialogClose>
              <Button
                type="button"
                variant="outline"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
            </DialogClose>
            {!allDisabled && <Button type="submit">Save</Button>}
          </DialogFooter>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default PaymentBlockDialog;
